/**
 * 🌍 GLOBAL STANDART KOD (TÜM PROJELER İÇİN GEÇERLİDİR)
 *
 * Bu dosya QubePro ekosisteminde ortak (global) standarttır.
 * Tek kaynak `qubepro-core` reposudur; uydu repolarda kalıcı değişiklik yapılmaz.
 * Değişiklik gerekiyorsa Core'da güncellenir ve senkron ile diğer repolara yayılır.
 */
import type { ReactNode } from 'react';
import { usePermission } from '../../hooks/usePermission';
import { useAuth } from '../../context/AuthContext';
import { useTranslation } from '../../hooks/useTranslation';

/** Do not mount a settings page (or start its reads) without the corresponding capability. */
export function SettingsPageAccess({ permission, children }: { permission: string | readonly string[]; children: ReactNode }) {
  const { hasPermission } = usePermission();
  const { language } = useAuth();
  const t = useTranslation(language);
  // A combined workspace is accessible with any declared capability. Its sections
  // and each server endpoint still enforce their own read/write permissions.
  const allowed = typeof permission === 'string' ? hasPermission(permission) : permission.some(hasPermission);
  return allowed ? <>{children}</> : <p role="alert">{t.common.noPermission}</p>;
}
